import { useState } from "react";
import TooltipContainer from "../TooltipContainer"
import toast from "react-hot-toast";
import useMethodStore, { useMethodActions } from "@/store/MethodStore";

function AboutSettings() {

  const { setShowBSOD } = useMethodActions();
  const showBSOD = useMethodStore(state => state.showBSOD)

  const [isUpdating, setIsUpdating] = useState(false);
  const [updateStatus, setUpdateStatus] = useState("")
  const [updateProgress, setUpdateProgress] = useState(0);

  const startFakeUpdate = () => {
    setIsUpdating(true)
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUpdateProgress(progress);

      // Update status messages
      if (progress === 10) {
        setUpdateStatus("Downloading more bugs... 🐛");
      } else if (progress === 30) {
        setUpdateStatus("Installing bloatware... 💾");
      } else if (progress === 50) {
        setUpdateStatus("Removing useful features... 🔥");
      } else if (progress === 70) {
        setUpdateStatus("Adding complexity... 🤯");
      } else if (progress === 90) {
        setUpdateStatus("Finalizing lack of functionality... 🎉");
      } else if (progress >= 100) {
        clearInterval(interval);
        setTimeout(() => {
          setIsUpdating(false)
          setShowBSOD(true);
        }, 1000);
      }
    }, 1200);
  };


  return (
    <>
      <div className="w-full bg-zinc-200 dark:bg-zinc-800 py-2 px-3 rounded-md">
        <p>Made by <TooltipContainer tooltip="Portfolio"><a href="https://dhvanitmonpara.in" target="_blank" rel="noopener noreferrer" className="text-zinc-700 dark:text-zinc-300 hover:underline">Dhvanit Monpara</a></TooltipContainer>. Also visit my <TooltipContainer tooltip="Github"><a href="https://github.com/dhvanitmonpara" target="_blank" rel="noopener noreferrer" className="text-zinc-700 dark:text-zinc-300 hover:underline">Github</a></TooltipContainer> to know more about me.</p>
        <p>Took inspiration from <TooltipContainer tooltip="Anurag Kochar"><a href="https://os.anuragkochar.com/" target="_blank" rel="noopener noreferrer" className="text-zinc-700 dark:text-zinc-300 hover:underline">Anurag Kochar's OS</a></TooltipContainer>.</p>
      </div>
      <div className="w-full bg-zinc-200 dark:bg-zinc-800 py-2 px-3 rounded-md">
        <p>BTW this OS got some cool <a href="https://www.google.com/search?q=what+means+easter+eggs+in+tech%3F&newwindow=1&sca_esv=b3f94a2ddadc3e46&sxsrf=AHTn8zrXqDgCj8hErR0Dfp1wP2Mkbbftkw%3A1738144790611&ei=FvyZZ5HpJPih0-kPzpHu4AE&ved=0ahUKEwiRzL_21ZqLAxX40DQHHc6IGxwQ4dUDCBE&uact=5&oq=what+means+easter+eggs+in+tech%3F&gs_lp=Egxnd3Mtd2l6LXNlcnAiH3doYXQgbWVhbnMgZWFzdGVyIGVnZ3MgaW4gdGVjaD8yBRAhGKABMgUQIRigATIFECEYoAEyBRAhGKABSIJ2UOYFWJE7cAN4AZABApgBiQmgAfA7qgEPMC4xLjMuMy4zLjEuMy4xuAEDyAEA-AEBmAIKoAKiF8ICChAAGLADGNYEGEfCAgYQABgKGB7CAgYQABgIGB7CAgsQABiABBiGAxiKBcICCBAAGBYYChgewgIGEAAYFhgewgIHECEYoAEYCpgDAIgGAZAGCJIHDTMuMS4xLjIuMi4wLjGgB5ZT&sclient=gws-wiz-serp" target="_blank" rel="noopener noreferrer" className="text-zinc-700 dark:text-zinc-300 hover:underline">easter eggs</a>. I dare you to find them :&#41;</p>
      </div>
      <div className="w-full bg-zinc-200 dark:bg-zinc-800 p-2 px-3 rounded-md">
        <p>You are running LackOS v.20.47.69. And this is the latest version changelog:</p>
        <ul className="list-disc list-inside mt-2">
          <li>Added quantum computing support (still experimental).</li>
          <li>Fixed a bug where coffee maker occasionally produced decaf.</li>
          <li>Optimized the "Procrastination Module" for better performance.</li>
          <li>Added a new feature: "Infinite Scroll for Cat Memes."</li>
          <li>Removed the "Monday Morning" bug (replaced with "Friday Afternoon" mode).</li>
          <li>Improved compatibility with pizza-based workflows.</li>
          <li>Integrated new closedAI model so we can steal your data.</li>
          <li>Added a secret Easter egg (you're already close to finding it).</li>
          <li>Fixed the "Infinite Loop of Dad Jokes" (just kidding, it's still there).</li>
        </ul>
        <div className="flex flex-col justify-center items-center py-4">

          {/* Fake Update Progress Bar */}
          {isUpdating &&
            <div className="mt-4 w-full max-w-md bg-zinc-200 dark:bg-zinc-800 p-4 rounded-md"> {/* Removed "hidden" */}
              <p className="text-center">Updating LackOS...</p>
              <div className="w-full bg-zinc-300 dark:bg-zinc-700 h-2 rounded mt-2">
                <div
                  className="bg-blue-600 h-2 rounded transition-all duration-300" // Added smooth transition
                  style={{ width: `${updateProgress}%` }}
                ></div>
              </div>
              <p className="text-center mt-2">
                {updateStatus}
              </p>
            </div>
          }

          {!isUpdating && <TooltipContainer
            delayDuration={10}
            side="bottom"
            tooltip="Spoiler alert, This is more of a downgrade in name of update"
          >
            <button
              disabled={isUpdating}
              className="mt-4 px-4 py-2 rounded-3xl bg-blue-600 text-white hover:bg-blue-600"
              onClick={startFakeUpdate}
            >
              Update Now to lack more
            </button>
          </TooltipContainer>}

          {showBSOD === false && updateProgress === 100 && (
            <div className="mt-4 text-center">
              <button
                className="px-4 py-2 rounded-3xl bg-red-600 text-white hover:bg-red-700"
                onClick={() => {
                  setUpdateProgress(0);
                  toast("Smart choice! Updates are overrated anyway. 😎");
                }}
              >
                Never Update Again
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default AboutSettings